import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-footer-settings',
  templateUrl: './footer-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpFooterSettingsComponent extends OmpSectionSettings {
  @Input() visible = true;
  @Output() visibleChange = new EventEmitter<boolean>();
}
